import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import GetIndexCategoriesForAllOrganisationsInteractor from "../../organisations/interactors/GetIndexCategoriesForAllOrganisationsInteractor";
import CategoryIndexBulkEditorPresenter, {
  ICategoryIndexBulkEditorPresenter
} from "../presenter/CategoryIndexBulkEditorPresenter";
import GetAllIndexTypeGroupsForCategoryInteractor from "./GetAllIndexTypeGroupsForCategory";
import GetAllIndexTypesInteractor from "./GetAllIndexTypesInteractor";

export default class ShowCategoryIndexBulkEditorInteractor {
  private application: Application;
  private output?: ICategoryIndexBulkEditorPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;
  private getIndexCategoriesForAllOrganisations: GetIndexCategoriesForAllOrganisationsInteractor;
  private getAllIndexTypeGroupsForCategory: GetAllIndexTypeGroupsForCategoryInteractor;
  private getAllIndexTypes: GetAllIndexTypesInteractor;
  constructor({
    application,
    getAllOrganisations,
    getIndexCategoriesForAllOrganisations,
    getAllIndexTypeGroupsForCategory,
    getAllIndexTypes
  }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
    this.getIndexCategoriesForAllOrganisations =
      getIndexCategoriesForAllOrganisations;
    this.getAllIndexTypeGroupsForCategory = getAllIndexTypeGroupsForCategory;
    this.getAllIndexTypes = getAllIndexTypes;
  }

  private async getReferenceValues(categoryTypeId: number) {
    return Promise.all([
      this.getAllOrganisations.execute(),
      this.getIndexCategoriesForAllOrganisations.execute(categoryTypeId),
      this.getAllIndexTypeGroupsForCategory.execute(categoryTypeId),
      this.getAllIndexTypes.execute()
    ]);
  }

  execute(categoryTypeId: number) {
    this.output = CategoryIndexBulkEditorPresenter({
      application: this.application,
      initialState: {
        organisations: [],
        indexGroupTypes: [],
        indexTypes: [],
        organisationIndexCategories: [],
        categoryTypeId
      }
    });
    this.getReferenceValues(categoryTypeId).then(
      this.output.loadReferenceValues
    );
    return this.output;
  }
}
